import { IconButton, Tooltip } from "@mui/material";
import "./colortheme-input-component.scss";

interface ColorthemeInputComponentProps {
  value: string;
  label?: string;
  handleColorChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  disabled?: boolean;
}

const ColorthemeInputComponent: React.FC<ColorthemeInputComponentProps> = ({
  value,
  handleColorChange,
  label,
  name,
  disabled,
}) => {
  return (
    <div className="colorthemContainer">
      <Tooltip title="Pick a color">
        <label
          htmlFor={name}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
          }}
        >
          <IconButton
            component="span" // use span to avoid nesting label inside label
            sx={{
              width: "16px",
              height: "16px",
              borderRadius: "4px",
              backgroundColor: value,
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
            disabled={disabled}
          />
          {label && <span className="colortheme-label">{label}</span>}
        </label>
      </Tooltip>
      <input
        type="color"
        id={name}
        name={name}
        value={value || "#000000"}
        onChange={handleColorChange}
        disabled={disabled}
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          opacity: 0,
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

export default ColorthemeInputComponent;
